import axios from "axios";
import { authHeader } from "../helpers/auth-header";

const getList = () => {
    return axios.get(`/api/ExhibitionScenario`, { headers: authHeader() })
        .then((res) => { return res.data});
}

const getById = (id) => {
    return axios.get(`/api/ExhibitionScenario/${id}`, { headers: authHeader() })
        .then((res) => { return res.data});
}

const create = (exhibitionScenarioModel) => {
    delete exhibitionScenarioModel['id'];
    return axios.post(`/api/ExhibitionScenario`, exhibitionScenarioModel ,{ headers: authHeader() })
        .then((res) => { return res.data});
}

const edit = (exhibitionScenarioModel) => {
    return axios.patch(`/api/ExhibitionScenario/${exhibitionScenarioModel.id}`, exhibitionScenarioModel ,{ headers: authHeader() })
        .then((res) => { return res.data});
}

const remove = (id) => {
    return axios.delete(`/api/ExhibitionScenario/${id}`,{ headers: authHeader() })
        .then((res) => { return res.data});
}

const getDropdownList = () => {
    return axios.get(`/api/ExhibitionScenario/getDropdownList`)
        .then((res) => { return res.data })
}

export const exhibitionScenarioService = {
    getList,
    getById,
    create,
    edit,
    remove,
    getDropdownList
}